module.exports = __webpack_public_path__ + "static/media/fontello.14cad44f.woff2";